'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _lodash = require('lodash');

var _createMarkup = require('../../../utils/react/createMarkup');

var _createMarkup2 = _interopRequireDefault(_createMarkup);

require('./RichMediaIFrameContent.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Lib


// Utils


// Styles


var getIFramePlayerPadding = function getIFramePlayerPadding(mediaData) {
    var ratio = mediaData.get('height') / mediaData.get('width');
    return {
        paddingBottom: Math.floor(ratio * 100) + '%'
    };
};

var RichMediaIFrameContent = function (_React$Component) {
    _inherits(RichMediaIFrameContent, _React$Component);

    function RichMediaIFrameContent(props) {
        _classCallCheck(this, RichMediaIFrameContent);

        var _this = _possibleConstructorReturn(this, (RichMediaIFrameContent.__proto__ || Object.getPrototypeOf(RichMediaIFrameContent)).call(this, props));

        _this.dispatchReady = function () {
            if (_this.isReady) return;

            _this.isReady = true;
            _this.props.dispatchRichMediaReady();
        };

        _this.isReady = false;
        return _this;
    }

    _createClass(RichMediaIFrameContent, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            // Wait two seconds before transitioning to the player in case the load event doesn't fire
            this.mountTimer = (0, _lodash.delay)(this.dispatchReady, 2000);

            if (!this.container) return;

            var iFrame = this.container.querySelector('iframe.embedly-embed');
            if (!iFrame) return;

            iFrame.addEventListener('load', this.dispatchReady);
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var mediaData = this.props.mediaData;


            if (!mediaData) return null;

            var iFrameContent = mediaData.get('html');

            return _react2.default.createElement('div', { className: 'RichMediaIFrameContent', ref: function ref(c) {
                    _this2.container = c;
                },
                style: getIFramePlayerPadding(mediaData),
                dangerouslySetInnerHTML: (0, _createMarkup2.default)(iFrameContent) });
        }
    }]);

    return RichMediaIFrameContent;
}(_react2.default.Component);

RichMediaIFrameContent.propTypes = {
    mediaData: _propTypes2.default.object,
    dispatchRichMediaReady: _propTypes2.default.func
};

exports.default = RichMediaIFrameContent;


//////////////////
// WEBPACK FOOTER
// ./src/client/element/richMedia/components/RichMediaIFrameContent.js
// module id = 2011
// module chunks = 0